import { useEffect, useState } from 'react'

import { Tab } from 'components'
import { useTabs } from 'hooks'
import { TabsProvider } from 'hooks/useTabs/provider'
import { useLocation } from 'react-router-dom'
import {
  MotivoBloqueioServices,
  MotivosBloqueioInterface
} from 'services/NGT/RecordsSheet'

import { AddRecordSheet, RecordSheetForm } from './components'
import { IdataTable } from './components/RecordSheetForm'
import SearchRecordsSheet from './components/SearchRecordsSheet'

export interface IRedirectData {
  cdContrato: string
  nmFornecedor: string
  idFornecedor: number
  pathBack: string
  tabBack: number
}

const RecordSheetComponent: React.FC = () => {
  const location = useLocation<any>()
  const defaultTabs = ['Pesquisar', 'Novo Bloqueio', 'Nova Folha de Registro']
  const {
    controlTabs,
    selectedTab,
    handleChangeTabName,
    handleRemoveTab,
    rawTabs
  } = useTabs(defaultTabs)

  const [dataTable, setDataTable] = useState<IdataTable>()
  const [motivosBloqueio, setMotivosBloqueio] = useState<
    MotivosBloqueioInterface[]
  >([])
  const [, setSelectedTab] = useState<number>(0)

  const getMotivosBloqueio = () => {
    MotivoBloqueioServices()
      .GetALL()
      .then(({ data }) => {
        setMotivosBloqueio(data)
      })
  }

  useEffect(() => {
    if (selectedTab.position === 0) {
      location.state = {}
    }

    if (controlTabs.tabs.length !== 0) {
      if (controlTabs.tabs.length == 3) {
        if (selectedTab.position < 2) {
          handleChangeTabName('Nova Folha de Registro', 2)
        }
      } else {
        if (selectedTab.position != 3) {
          handleRemoveTab({
            removeAndNavigateToPreviousDefaultTab: false,
            tabName: rawTabs[3].name
          })
        }
      }
    }
  }, [selectedTab])

  useEffect(() => {
    getMotivosBloqueio()
  }, [])

  return (
    <>
      <Tab {...controlTabs} />
      {selectedTab.position === 0 && (
        <SearchRecordsSheet
          setDataTable={setDataTable}
          setSelectedTab={setSelectedTab}
          redirectData={location?.state}
          motivosBloqueio={motivosBloqueio}
        />
      )}
      {selectedTab.position === 1 && (
        <RecordSheetForm
          newBlock={true}
          setDataTable={setDataTable}
          dataTable={dataTable}
          redirectData={location?.state}
          motivosBloqueio={motivosBloqueio}
        />
      )}
      {selectedTab.position === 2 && <AddRecordSheet />}
      {selectedTab.position === 3 && (
        <RecordSheetForm
          newBlock={false}
          setDataTable={setDataTable}
          dataTable={dataTable}
          redirectData={location?.state}
          motivosBloqueio={motivosBloqueio}
        />
      )}
    </>
  )
}

const RecordSheet: React.FC = () => {
  return (
    <TabsProvider>
      <RecordSheetComponent />
    </TabsProvider>
  )
}

export default RecordSheet
